import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import { formatImage } from '@ifeng-fe/public_method';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const Banner = ({ content }) => {
    const swiperRef = useRef();

    return (
        <Chip id="260718" title="顶部banner图轮播图" groupName="中国力量" type="struct">
            <div className={styles.banner}>
                <Swiper
                    modules={[Navigation, Mousewheel, Keyboard]}
                    speed={1500}
                    allowTouchMove={false}
                    keyboard={{
                        enabled: true,
                    }}
                    loop={true}
                    navigation={{ prevEl: `.${styles.prevBox}`, nextEl: `.${styles.nextBox}` }}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}>
                    {content.map((item, index) => {
                        return (
                            <SwiperSlide key={index}>
                                {item.linkUrl ? (
                                    <a href={item.linkUrl} target="_blank" rel="noreferrer">
                                        <img className={styles.swiperPic} src={item.imageUrl} />
                                    </a>
                                ) : (
                                    <img className={styles.swiperPic} src={item.imageUrl} />
                                )}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                {content.length > 1 ? (
                    <>
                        <div className={`${styles.prevBox}`}>
                            <img className={styles.prev} src="https://x0.ifengimg.com/ucms/2023_37/1C09EA0C5522D27EB72046A4A4EAD59476D13455_size6_w55_h100.png" alt="" />
                        </div>
                        <div className={styles.nextBox}>
                            <img className={styles.next} src="https://x0.ifengimg.com/ucms/2023_37/8132B8DBAE876766F6EABDC51ADD110298152FC5_size6_w55_h100.png" alt="" />
                        </div>
                    </>
                ) : null}
            </div>
        </Chip>
    );
};

Banner.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(Banner);
